/* Follow the theme's existing desktop disclosure; leave its links intact. */
(() => {
  if (window.vnaDesktopMenuInstalled) return;
  window.vnaDesktopMenuInstalled = true;
  const setup = () => {
    window.vnaDesktopMenuController?.abort();
    const controller = new AbortController();
    window.vnaDesktopMenuController = controller;
    const { signal } = controller;
    const header = document.querySelector('.section-header-navigation');
    const navigation = header?.querySelector('#HeaderNavigation');
    if (!navigation) return;
    const desktop = matchMedia('(min-width: 1280px) and (hover: hover)');
    const backdrop = document.createElement('div');
    backdrop.className = 'vna-desktop-menu-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.append(backdrop);
    let frame = 0;
    const items = () => [...navigation.querySelectorAll(':scope > .header__inline-menu > .list-menu > .menu-lv-1')];
    const close = () => document.body.classList.remove('vna-desktop-menu-open');
    const update = () => {
      frame = 0;
      if (!desktop.matches || !header.isConnected || header.inert) {
        close();
        return;
      }
      const localization = header.querySelector('.vna-localization-switcher--desktop .vna-localization-switcher__disclosure[open]');
      const active = localization || items().find(item => {
        const submenu = item.querySelector('.header__submenu, .menu-dropdown');
        if (!submenu || item.classList.contains('vna-menu-dismissed')) return false;
        if (!item.matches(':hover') && !item.contains(document.activeElement)) return false;
        const style = getComputedStyle(submenu);
        return style.display !== 'none' && style.visibility === 'visible' && submenu.getBoundingClientRect().height > 0;
      });
      if (active) {
        const bottom = Math.max(0, header.getBoundingClientRect().bottom);
        backdrop.style.setProperty('--vna-menu-backdrop-top', `${bottom}px`);
      }
      document.body.classList.toggle('vna-desktop-menu-open', Boolean(active));
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    header.addEventListener('toggle', schedule, { capture: true, signal });
    header.addEventListener('focusin', schedule, { signal });
    navigation.addEventListener('pointerover', event => {
      const item = event.target.closest('.menu-lv-1');
      if (item?.querySelector('.header__submenu, .menu-dropdown')) {
        header.querySelectorAll('.vna-localization-switcher--desktop .vna-localization-switcher__disclosure[open]').forEach(disclosure => { disclosure.open = false; });
      }
      schedule();
    }, { signal });
    navigation.addEventListener('pointerout', event => {
      const item = event.target.closest('.menu-lv-1');
      if (item && !item.contains(event.relatedTarget)) item.classList.remove('vna-menu-dismissed');
      schedule();
    }, { signal });
    navigation.addEventListener('focusin', schedule, { signal });
    navigation.addEventListener('focusout', event => {
      const item = event.target.closest('.menu-lv-1');
      if (item && !item.contains(event.relatedTarget)) item.classList.remove('vna-menu-dismissed');
      schedule();
    }, { signal });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !desktop.matches || !document.body.classList.contains('vna-desktop-menu-open')) return;
      const disclosure = header.querySelector('.vna-localization-switcher--desktop .vna-localization-switcher__disclosure[open]');
      if (disclosure) {
        disclosure.open = false;
        disclosure.querySelector('summary')?.focus();
      }
      for (const item of items()) {
        if (!item.matches(':hover') && !item.contains(document.activeElement)) continue;
        item.classList.add('vna-menu-dismissed');
        if (item.contains(document.activeElement)) item.querySelector('.menu-lv-1__action')?.focus();
      }
      close();
    }, { capture: true, signal });
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    window.addEventListener('blur', close, { signal });
    desktop.addEventListener('change', () => {
      items().forEach(item => item.classList.remove('vna-menu-dismissed'));
      if (!desktop.matches) header.querySelectorAll('.vna-localization-switcher--desktop .vna-localization-switcher__disclosure[open]').forEach(disclosure => { disclosure.open = false; });
      schedule();
    }, { signal });
    const resize = new ResizeObserver(schedule);
    resize.observe(header);
    const mutations = new MutationObserver(schedule);
    mutations.observe(header, { childList: true, subtree: true });
    signal.addEventListener('abort', () => {
      cancelAnimationFrame(frame);
      resize.disconnect();
      mutations.disconnect();
      items().forEach(item => item.classList.remove('vna-menu-dismissed'));
      close();
      backdrop.remove();
    }, { once: true });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('.section-header-navigation') || event.target.querySelector?.('.section-header-navigation')) window.vnaDesktopMenuController?.abort();
  });
})();
